import React, { useRef, useState } from 'react';
import styles from './OnboardingVideoCard.module.scss';
import cx from 'classnames';
import { CustomButton } from '../../../../components/Button/Button';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../../components/Tooltip/Tooltip';

const OnboardingVideoCard = ({ link, title, description, thumbnail }) => {
  const [isHover, setIsHover] = useState(false);

  const { t } = useTranslation();

  const descriptionRef = useRef(null);

  const handleClick = () => {
    window.open(link, '_blank');
  };

  const handleHoverOverDescription = e => {
    if (descriptionRef?.current.offsetWidth < descriptionRef?.current.scrollWidth) {
      setIsHover(true);
    }
  };

  const handleHoverLeaveDescription = () => {
    setIsHover(false);
  };

  return (
    <div className={styles.playerContainer}>
      <div className={styles.thumbnail}>
        <img className={cx(styles.image)} src={thumbnail} alt={'Click for Details'} />
      </div>

      <div className={styles.startVideoFooter}>
        <div className={styles.footerText}>
          <span className={styles.startVideoTitle}>{t(title)}</span>
          <span
            ref={descriptionRef}
            onMouseEnter={handleHoverOverDescription}
            onMouseLeave={handleHoverLeaveDescription}
            className={styles.description}
          >
            {t(description)}
          </span>
          <Tooltip text={t(description)} isHover={isHover} moveable={false} />
        </div>
        <div>
          <CustomButton
            className={styles.actionBtn}
            variant="primary"
            onClick={handleClick}
            label={t('home_page.first_video.button')}
          />
        </div>
      </div>
    </div>
  );
};

export default OnboardingVideoCard;
